import * as React from "react";
import * as ReactDOM from "react-dom";
import cx from "classnames";
import { Theme as theme } from "../../entryes/panel/MUI";
import { ReactMicGold } from "@hackingbeautyllc/react-mic-plus/dist";
import * as moment from "moment";
import { Popup, SvgIcon } from "../../components";
import * as styles from "./styles.scss";

const translator: any = (window as any).$.translator,
  locales: any = {
    cancel: translator.translate("Отмена"),
    audiorecord: {
      micDisabled: translator.translate("Запись с микрофона невозможна."),
      micDisabledNote: translator.translate(
        "Но вы можете записать аудио на свое устройство и прикрепить его, выбрав файл записи."
      ),
      micDisallowed: translator.translate(
        "Разрешите браузеру использовать микрофон вашего устройства."
      ),
      https1: translator.translate(
        "Для записи аудио с микрофона, пожалуйста, перейдите на защищенное соединение"
      ),
      https2: translator.translate("все несохраненные данные будут потеряны"),
      https3: translator.translate("или загрузите файл."),
      recordFail: translator.translate("Ошибка при записи."),
    },
  };

export class AudioRecorder extends React.Component<
  {
    onStart?: any;
    onStopRecording?: any;
    onCancel?: any;
    recordOnDemand?: boolean;
    isHttps?: boolean;
    httpsUrl?: string;
    maxTime?: number;
  },
  {
    isActive: boolean;
    isRecord: boolean;
    isCanceled: boolean;
    modal: string | "https" | "disabled" | "disallowed" | "fail";
    timeElapsed: number;
  }
> {
  state = {
    isActive: !this.props.recordOnDemand,
    isRecord: false,
    isCanceled: false,
    modal: "",
    timeElapsed: 0
  };

  recordTimer: any = null;
  timerCurrent: number = 0;
  timerRef: any = null;
  iconTitle: string;
  maxTime: number;
  stopRef: HTMLDivElement = null;
  
  constructor(props: any, state: any) {
    super(props, state);
    this.onTick.bind(this);
  }

  resetTimer() {
    clearInterval(this.recordTimer);
    this.timerCurrent = 0;
  }

  onCancel(record?: any) {
    this.resetTimer();
    this.setState({ ...this.state, isRecord: false, isCanceled: true, timeElapsed: 0 });
    clearInterval(this.recordTimer);
    if (!!this.props.onCancel) {
      this.props.onCancel(record);
    }
  }

  onStop(evt: any) {
    this.resetTimer();
    this.setState({ ...this.state, isRecord: false }, () => {
      this.setState({
        ...this.state,
        isRecord: false,
        isActive: false,
        timeElapsed: 0,
      });
    });
    if (evt) {
      $(evt.target)
      .closest(".js-audio-comment-container")
      .addClass("audio-comment_showAttach");
    }
  }

  onError() {
    this.setState({
      ...this.state,
      isRecord: false,
      modal: "fail",
    });
  }

  onTick() {
    if (this.props.maxTime) {
      const maxRecordLength = this.props.maxTime * 60;
      if (this.state.timeElapsed >= maxRecordLength) {
       this.onStop(this.stopRef)
       return;
      };
    }
    const nextTime = this.state.timeElapsed + 1;
    this.setState(prevState => ({
      ...prevState,
      timeElapsed: nextTime
    }))
    // if (this.timerCurrent >= 3 * 60) {
    //   this.onStop();
    // } else {
    // this.timerCurrent++;
    // if (this.timerCurrent > 2 * 60) {
    //   this.timerRef.innerHTML += "/ 3:00";
    // }
    // }
  }

  onStopRecording(record: any) {
    if (!this.state.isCanceled) {
      this.props.onStopRecording(record);
    }
  }

  componentDidMount() {
    if (!this.props.recordOnDemand) {
      this.setState({
        ...this.state,
        isRecord: true,
        isCanceled: false,
      });
    }
    switch (this.state.modal){
      case "disabled":
        this.iconTitle = `${locales.audiorecord.micDisabled} ${locales.audiorecord.micDisabledNote}`;
        break;
      case "disallowed":
        this.iconTitle = `${locales.audiorecord.micDisabled} ${locales.audiorecord.micDisallowed}`;
        break;
    }

  }

  render() {
    return (
      <>
        <div className={styles.recorder}>
          {this.state.isRecord ? (
            <div
              className={styles.recorderWrap}
              style={{ borderColor: theme.palette.primary.light }}
            >
              {!this.state.isRecord || (
                <div className={styles.recorderCancel}>
                  <button
                    type="button"
                    onClick={this.onCancel.bind(this)}
                    style={{ color: theme.palette.primary.dark }}
                  >
                    <img
                      src="/public/images/pix.gif"
                      alt={locales.cancel}
                      className="svgicon svgicon-remove"
                    />
                    <span className="mobile-hide">{locales.cancel}</span>
                  </button>
                </div>
              )}
              <div
                className={styles.recorderBody}
                style={{ backgroundColor: theme.palette.primary.light }}
              >
                <div className={styles.recorderBar}>
                  {this.state.isActive && (window as any).AudioContextExist ? (
                    <ReactMicGold
                      record={this.state.isRecord}
                      className="sound-wave"
                      onStop={(rec: any) => {
                        if (rec.blob.size === 0) {
                          this.onError();
                        } else {
                          this.onStopRecording(rec);
                        }
                      }}
                      onStart={() => {
                        if (this.timerCurrent === 0) {
                          this.recordTimer = setInterval(() => {
                            this.onTick();
                          }, 1000);
                        }
                      }}
                      bitRate={192000}   
                      onBlock={() => {
                        this.setState({
                          ...this.state,
                          isRecord: false,
                          modal: "disallowed"
                        });
                        this.iconTitle = `${locales.audiorecord.micDisabled} ${locales.audiorecord.micDisallowed}`;
                      }}
                      strokeColor="#ffffff"
                      backgroundColor={theme.palette.primary.light}
                      height={32}
                      visualSetting="frequencyBars"
                    />
                  ) : null}
                </div>
                <div
                  className="wasTooltiped"
                  title={`Максимальная продолжительность записи ${this.props.maxTime || 3}&nbsp;мин.`}
                  ref={(ref) => (this.timerRef = ref)}
                >
                  {this.props.maxTime 
                    ? moment.unix(this.props.maxTime * 60 - this.state.timeElapsed).format("mm:ss")
                    : moment.unix(this.state.timeElapsed).format("mm:ss")
                  }
                </div>
                <div
                  className={cx(styles.recorderPulsar, {
                    invisible: !this.state.isRecord,
                  })}
                >
                  <span className="svgicon svgicon-onAir" />
                </div>
              </div>
            </div>
          ) : null}
          {this.state.isRecord ? (
            <div
              className={styles.recorderSend}
              ref={ref => this.stopRef = ref}
              onClick={(evt: any) => {
                this.onStop(evt);
              }}
            >
              <SvgIcon type="hw-stop" />
            </div>
          ) : (
            <div
              className={cx(styles.recorderSend, "js-audio-comment-start", {
                "disabled wasTooltiped showAnyWidth":
                  !navigator.mediaDevices || !(window as any).AudioContextExist,
              })}
              onClick={() => {
                if (
                  !navigator.mediaDevices ||
                  !(window as any).AudioContextExist
                ) {
                  this.setState({
                    ...this.state,
                    modal: "disabled",
                  });
                } else {
                  this.setState({
                    ...this.state,
                    isActive: true,
                    isRecord: true,
                    isCanceled: false,
                  });
                }
              }}
              title={this.iconTitle}
            >
              <SvgIcon type="hw-audio" />
            </div>
          )}
        </div>
        <Popup
          header={translator.translate("Внимание!")}
          bottomCSSModifier="mobile-wrap"
          width="464px"
          bottom={
            this.state.modal !== "disallowed" ? (
              <>
                {this.state.modal === "https" ? null : (
                  <div className="modal-panel__section" />
                )}
                <div className="modal-panel__section">
                  <span
                    className="button button_lighter"
                    onClick={() => {
                      this.onCancel();
                      this.setState({
                        ...this.state,
                        modal: "",
                      });
                    }}
                  >
                    {translator.translate("Отмена")}
                  </span>
                </div>
                {this.state.modal === "https" ? (
                  <div className="modal-panel__section">
                    <a href={this.props.httpsUrl} className="button">
                      {translator.translate("Перейти")}
                    </a>
                  </div>
                ) : null}
              </>
            ) : null
          }
          isVisible={
            this.state.modal === "https" ||
            this.state.modal === "disabled" ||
            this.state.modal === "disallowed" ||
            this.state.modal === "fail"
          }
          onClose={() => {
            this.onCancel();
            this.setState({
              ...this.state,
              modal: "",
            });
          }}
          onCancel={() => {
            this.onCancel();
            this.setState({
              ...this.state,
              modal: "",
            });
          }}
        >
          {this.state.modal === "https" ? (
            <>
              {locales.audiorecord.https1} <br />
              <b>({locales.audiorecord.https2})</b> <br />
              {locales.audiorecord.https3}
            </>
          ) : this.state.modal === "disabled" ? (
            <>
              <b>{locales.audiorecord.micDisabled}</b>
              <br />
              {locales.audiorecord.micDisabledNote}
            </>
          ) : this.state.modal === "disallowed" ? (
            <>
              <b>{locales.audiorecord.micDisabled}</b>
              <br />
              {locales.audiorecord.micDisallowed}
            </>
          ) : this.state.modal === "fail" ? (
            <>
              <b>{locales.audiorecord.recordFail}</b>
              <br />
              {locales.audiorecord.micDisabledNote}
            </>
          ) : (
            locales.audiorecord.micDisabled
          )}
        </Popup>
      </>
    );
  }
}

(window as any).react_render_audiorecorder = (nodeId: string, data: any) => {
  ReactDOM.render(
    <AudioRecorder
      onStart={data.onStart}
      onStopRecording={data.onStopRecording}
      onCancel={data.onCancel}
      recordOnDemand={data.recordOnDemand}
      isHttps={data.isHttps}
      httpsUrl={data.httpsUrl}
      maxTime={data.maxTime}
    />,
    document.getElementById(nodeId)
  );
};
